import { create } from 'zustand';
import { FilterCategory, FrontendFilterType } from '../../types/filters.type';
import { createFilterTypeLookup } from '../../utils/filters';
// tech debt ticket: CI-186 to filter static/optimise filters
// the fetch could happen in a get here and store as a state to be used in streetview

export interface AllFilterStoreState{
  filterTypeLookup: Record<string, FrontendFilterType>;
  setFilterTypeLookup: (allFilters: FilterCategory[]) => void;
}
const useAllFilterStore = create<AllFilterStoreState>((set) => ({
  filterTypeLookup: {},
  setFilterTypeLookup: (allFilters: FilterCategory[]) => {
    const lookup = createFilterTypeLookup(allFilters);
    set({ filterTypeLookup: lookup });
  },
}));

export default useAllFilterStore;
